export const ae = {
    myGeotabLogin: {
        loginText: 'Log in',
        registerText: 'Register',
    },
    notFound: {
        title: '404 Not Found | Geotab',
        heading: 'Oh no!',
        description: 'The page you were looking for could not be found.',
        description2: 'Try searching or go back to',
        homepageLink: 'our homepage',
        redirectLink: '/',
    },
    salesforce: {
        formLanguage: 'Middle East ML',
    },
    authorBiography: {
        authorOverview: {
            leanMoreAbout: 'Learn more about',
        },
        publications: 'Publications',
    },
    formPlaceholders: {
        firstNamePlaceholder: 'Enter a first name\u2026',
        lastNamePlaceholder: 'Enter a last name\u2026',
        phonePlaceholder: 'Enter a phone number\u2026',
        emailPlaceholder: 'Enter an email\u2026',
        companyPlaceholder: 'Enter a company\u2026',
        yourCompanyPlaceholder: 'Enter your company\'s name\u2026',
        cityPlaceholder: 'Enter a city\u2026',
        commentsPlaceholder: 'Enter any questions/comments\u2026',
        fleetPlaceholder: 'Select a fleet size\u2026',
        approxFleetPlaceholder: 'Select an approximate fleet size\u2026',
        industryPlaceholder: 'Select an industry category\u2026',
        countryPlaceholder: 'Select a country\u2026',
        fullNamePlaceholder: 'Enter a full name\u2026',
        messagePlaceholder: 'Enter a message\u2026',
        identityPlaceholder: 'Select a category\u2026',
        surnamePlaceholder: 'Enter a surname\u2026',
        statePlaceholder: 'Select a state\u2026',
        provincePlaceholder: 'Select a province\u2026',
        titlePlaceholder: 'Select a title\u2026',
        userTitlePlaceholder: 'Enter a title\u2026',
    },
    regionSelection: {
        seo: {
            title: 'Region Selection',
            description:
                'Select your country or region to learn about Geotab\'s fleet management software and vehicle tracking devices.',
        },
        title: 'Select your region',
        regions: {
            northSouthAmerica: 'North and South America',
            europe: 'Europe',
            asiaAustraliaMiddleEast: 'Asia, Australia, and Middle East',
        },
        regionChangeText: 'Change region',
    },
    blogTableContent: {
        title: 'Table of contents',
    },
    articleFAQ: {
        title: 'Frequently Asked Questions',
    },
    aboutAuthor: {
        about: 'About',
        currentRole: 'Current role',
        experties: 'Expertise',
        accomplishments: 'Accomplishments',
        education: 'Education',
        publications: 'Publications',
    },
    breadcrumb: {
        home: 'Home',
    },
};
